import React from 'react';
import PropTypes from 'prop-types';

const ProjectStore = require('../../stores/ProjectStore');
const StringUtil = require('../../../../app/shared/StringUtil');
import DateString from '../common/DateString';
import UserDisplayName from '../user/UserDisplayName';
import StatTile from '../tiles/StatTile';

const propTypes = {
    className: PropTypes.string,
    projectId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}

const defaultProps = {
    className: ''
}

class ProjectDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            projectStoreState: ProjectStore.getStateProject(this.props.projectId),
        };

        this.unsubscribes = [
            ProjectStore.listen(this.onProjectStoreStateChange.bind(this)),
        ];
    }

    componentDidUpdate(prevProps) {
        if (this.props.projectId !== prevProps.projectId) {
            this.setState({
                projectStoreState: ProjectStore.getStateProject(this.props.projectId)
            }); 
        }       
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onProjectStoreStateChange(state) {
        this.setState({
            projectStoreState: ProjectStore.getStateProject(this.props.projectId)
        });
    }

    render() {
        if (!this.state.projectStoreState.initialized) {
            return null;
        }

        const project = this.state.projectStoreState.project;
        if (!project) {
            console.warn(`ProjectDetails: Project id ${this.props.projectId} not found in store.`);
            return null;
        }

        return (
            <div className={`stat-tile-row-flex ${this.props.className}`}>
                <StatTile
                    className="text-centered bold-term"
                    term="Owner"
                >
                    <UserDisplayName id={project.channelId} />
                </StatTile>
                <StatTile
                    className="text-centered bold-term"
                    term="Created"
                >
                    <DateString shortMonth date={project.created_at} />
                </StatTile>
                <StatTile
                    className="text-centered bold-term"
                    term="Activities"
                >
                    {StringUtil.numberToLocaleString(project.activity_count)}
                </StatTile>
                <StatTile
                    className="text-centered bold-term"
                    term="Collaborators"
                >
                    {StringUtil.numberToLocaleString(project.project_collaborator_count)}
                </StatTile>
            </div>
        );
    }
}

ProjectDetails.propTypes = propTypes;
ProjectDetails.defaultProps = defaultProps;

export default ProjectDetails;